import React from "react";

import { Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DatePickerController = ({ control, name, rules, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => <DatePicker {...field} {...props} />}
    />
  );
};

export default DatePickerController;
